var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C6.47696 2.5 2 6.15916 2 10.6755C2 13.6142 3.89577 16.1896 6.7432 17.6307C6.53361 18.4371 5.98603 20.5557 5.87651 21.0087C5.74056 21.571 6.07477 21.5632 6.2957 21.4128C6.46752 21.2937 9.0355 19.4876 10.1439 18.7085C10.7462 18.8003 11.3656 18.8491 12 18.8491C17.523 18.8491 22 15.1899 22 10.6755C22 6.16112 17.523 2.5 12 2.5Z",
    fill: "#371D1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialKakao);
export default __webpack_public_path__ + "static/media/social-kakao.61773c211282265967326afdb4645a1c.svg";
export { ForwardRef as ReactComponent };